
































































































import {
  Vue,
  Component,
  Prop,
  Inject,
  Watch
} from "@/shared/vuepack";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import Input from "@/shared/components/ui/Input.vue";
import { Validator } from "vee-validate";

@Component ({
  components: {
    Input,
    UsStateSelector
  }
})
export default class EmployerAddress extends Vue {
  @Prop()
  value;

  @Prop()
  disallowPoBox: boolean;

  @Prop({required: true})
  id: string;

  @Prop()
  disabled: boolean;

  @Inject() $validator: Validator;

  addressModel = {
    addressLine1: "",
    addressLine2: "",
    state: "",
  };

  addressValidator (required) {
    return { isNotPoBox: this.disallowPoBox, required, max: 128 };
  }

  @Watch("value")
  onValueChange () {
    this.addressModel = {...this.value};
  }

  mounted () {
    this.onValueChange();
    this.checkIfPoBox();
  }

  onInput () {
    this.$emit("input", this.addressModel);
  }

  checkIfPoBox () {
    const mailingAddress1Name = `${this.id}.Address line 1`;
    const mailingAddress2Name = `${this.id}.Address line 2`;
    let address1 = true;
    let address2 = true;
    const addressModel = this.addressModel;
    if (addressModel.addressLine1 && addressModel.addressLine1.length > 0) {
      this.$validator.validate(mailingAddress1Name, addressModel.addressLine1)
        .then (address => address1 = address);
    }

    if (addressModel.addressLine2 && addressModel.addressLine2.length > 0) {
      this.$validator.validate(mailingAddress2Name, addressModel.addressLine2)
        .then (address => address2 = address);
    }

    this.$emit("address-is-po", !(address1 || address2));
  }

  hasError (name) {
    const scopedId = `${this.id}.${name}`;
    return this.$validator.errors.has(scopedId);
  }

  getError (name) {
    const scopedId = `${this.id}.${name}`;
    return this.$validator.errors.first(scopedId);
  }

  get isFormDisabled () {
    return this.disabled && this.disabled === true;
  }
}
